import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import LogingLogo from '../../images/loging_logo.png'
import { makeStyles, Container, Box, Grid, Card, Button, withStyles } from '@material-ui/core'
import Input from '../../components/abstractObjects/Input';
import AlertDialog from '../../components/abstractObjects/AlertDialog'
import { changeUserLanguage } from './user'
import { BasicLabel } from '../../components/abstractObjects/Label'
import { selectAllLanguages } from '../languages/languagesSlice'

const textFieldCss = makeStyles({
    root: {
        '& .MuiFormLabel-root': {
            color: '#4db5ff'
        },
        '& .MuiInput-underline': {
            color: '#1861ac'
        },
        marginBottom: '1rem'
    }
})

const BlueButton = withStyles({
    root: {
        color: "white",
        width: "100%",
    },
    disabled: {
        backgroundColor: '#4db5ff !important',
        color: "white !important",
    }
})((props) => <Button {...props} />)

export const UserLanguageForm = () => {
    const dispatch = useDispatch()
    const classesTextField = textFieldCss()
    const { user } = useSelector(state => state ? state.user : null)
    const languages = useSelector(selectAllLanguages);

    const [languageId, setLanguageId] = useState({ value: user.LanguageId, error: null })
    const [alertMessage, setAlertMessage] = useState({ title: null, message: null })
    const [alertActive, setAlertActive] = useState(false)

    const onSetLanguageId = (e) => setLanguageId({ value: e.target.value })

    const userChangeLanguage = async (e) => {
        e.preventDefault()
        var resultAction = await dispatch(
            changeUserLanguage({
                NewlanguageId: languageId.value
            })
        )
        if (resultAction.payload !== undefined && resultAction.payload.Code === 200) {
            window.location.reload()
            setAlertMessage({ message: "User has been changed", type: "success" })
        }
        else if (resultAction.payload !== undefined && resultAction.payload.Code === 500) {
            setAlertMessage({ message: resultAction.payload.Message, type: "error" })
        }
        else setAlertMessage({ message: "An error occurred, try again", type: "error" })
        setAlertActive(true)
    }

    const canSave = [languageId.value != user.LanguageId].every(Boolean)

    //, (languageId.value != user.LanguageId)

    return (<Container maxWidth="md">
        <Box mt="calc(9.5rem - 6%)">
            <Grid>
                <form>
                    <Card className="">
                        <Box p="5px" />
                        <Box mb="1.5rem" px="2rem" align="center" style={{ borderLeft: "5px solid #4db5ff" }}><img style={{ width: "90%" }} src={LogingLogo} alt="logo" /></Box>
                        <Box p="2rem 2rem 1rem 2rem" mb="1rem">
                            <Box>
                                {user.Name}<br /><br />
                                {user.Email}<br /><br />
                            </Box>
                            <Box>
                                <Input name="LanguageSelect" type="select" value={languageId.value} /*error={SupervisorId.error}*/ selectOptions={languages} onChange={onSetLanguageId} /*readonly={varx.ImSupervisor}*/ />
                            </Box>
                            <br />
                            <BlueButton variant="contained" color="primary" disabled={!canSave} onClick={userChangeLanguage} type="submit"><BasicLabel text="SAVE_CHANGES" /></BlueButton>
                        </Box>
                    </Card>
                </form>
                <AlertDialog alertActive={alertActive} setAlertActive={setAlertActive} info={alertMessage} />
            </Grid>
        </Box>
    </Container>);
}

export default UserLanguageForm;